'use strict';

const $ = require('jquery');

const MENU_BTN_SELECTOR = 'button.global-nav-bar__button.global-nav-bar__button--menu';
const MENU_SELECTOR = '.global-nav:visible';
const HEADSHOT_POPUP_BTN_SELECTOR = '.cast-overlay__container:visible';
const HEADSHOT_POPUP_CLASS = 'visible';
const HEADSHOT_POPUP_SELECTOR = '.cast-overlay__container:visible';


function closeMenu() {
    $(MENU_BTN_SELECTOR).click()
}

function closeHeadshotPopup($elem) {
    let $toggles = $elem.find(HEADSHOT_POPUP_BTN_SELECTOR);
    if ($toggles.length > 0) {
        $toggles.click();
    }

    $elem.removeClass(HEADSHOT_POPUP_CLASS);
}

function init() {
    $(document).keyup(function(e) {
        if (e.key === "Escape") {
            if ($(MENU_SELECTOR).length > 0) {
                closeMenu();
            }
            if ($(HEADSHOT_POPUP_SELECTOR).length > 0) {
                closeHeadshotPopup($(HEADSHOT_POPUP_SELECTOR));
            }
        }
    });
}

module.exports = {
    init: init
};
